import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { TemplateEditorView } from '@/features/contract-management/components/TemplateEditorView';

export const Route = createFileRoute('/_authenticated/contract-management/templates/new')({
  component: TemplateCreateRoute,
});

function TemplateCreateRoute() {
  const navigate = useNavigate();

  return (
    <TemplateEditorView
      mode="create"
      onBack={() => navigate({ to: '/contract-management' })}
    />
  );
}
